<template lang="pug">
el-form-item(label="Bullhorns")
  .p-3.bg-light.rounded
    .el-tag-wrapper(v-if="item.bullhorns && item.bullhorns.length")
      el-tag(
        type="info" :key="index"
        v-for="(bullhorn, index) in item.bullhorns"
      ) {{ bullhorn.bullhorn }}
    .empty-state(v-else)
      span.empty-text No bullhorns added yet

el-form-item(label="Values")
  .p-3.bg-light.rounded
    .el-tag-wrapper(v-if="item.values && item.values.length")
      el-tag(
        type="info" :key="index"
        v-for="(value, index) in item.values"
      ) {{ value.value }}
    .empty-state(v-else)
      span.empty-text No values added yet

el-form-item(label="Channels")
  .p-3.bg-light.rounded
    .el-tag-wrapper(v-if="item.channels && item.channels.length")
      el-tag(
        type="info" :key="index"
        v-for="(channel, index) in item.channels"
      ) {{ channel.channel }}
    .empty-state(v-else)
      span.empty-text No channels added yet

el-form-item.mb-0.mt-3(label="Interests")
  .p-3.bg-light.rounded
    .el-tag-wrapper(v-if="item.interests && item.interests.length")
      el-tag(
        type="info" :key="index"
        v-for="(interest, index) in item.interests"
      ) {{ interest.interest }}
    .empty-state(v-else)
      span.empty-text No interests added yet
</template>

<style lang="scss" scoped>
.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  min-height: 60px;
}

.empty-text {
  color: #9ca3af;
  font-size: 0.875rem;
  font-style: italic;
  font-weight: 500;
}

.el-tag-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

// Add gap above Interests
:deep(.el-form-item.mt-3) {
  margin-top: 1.5rem !important;
}
</style>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'UserCommonSections',

  props: {
    item: { type: Object, default: () => ({}) },
  },
});
</script>
